import { translate, type Locale } from "./translate";

// ---------------------------------------------------------------------------
// S74. "MY RECORD", WORDED ON THE SCREEN FROM THE COUNTS.
//
// `app.worker_reliability` composes each factor's sentence in English, which a
// Hungarian reader's catalogue cannot translate. Since 0218 it also returns the
// counts the sentence is built from; this composes the same sentence through the
// catalogue. In English it is the database's `sentence`, word for word, so the
// console reads what it always read (test/reliability.test.ts asserts it).
//
// The branch mirrors the function: the factor that counts arrivals (its
// `counts_arrivals`, 0267) is about turning up, every other one about being on
// time. The id is never spelled here; V28 keeps vocabulary in the database.
// ---------------------------------------------------------------------------

export type RecordCounts = {
  shifts_counted: number;
  shifts_arrived: number;
  shifts_on_time: number;
  shifts_set_aside: number;
};

export function factorSentence(locale: Locale, countsArrivals: boolean, c: RecordCounts): string {
  const base =
    countsArrivals
      ? c.shifts_counted === 0
        ? translate(locale, "None of your past shifts record arrivals, so turning up could not be measured and was left out of your record entirely.")
        : translate(locale, "You arrived for {arrived} of the {shifts} past shifts where arrivals are recorded.", {
            arrived: c.shifts_arrived,
            shifts: c.shifts_counted,
          })
      : c.shifts_arrived === 0
        ? translate(locale, "You have no recorded arrivals yet, so being on time could not be measured and was left out of your record entirely.")
        : translate(locale, "Of those {arrived} arrivals, {onTime} were inside the time the post allowed.", {
            arrived: c.shifts_arrived,
            onTime: c.shifts_on_time,
          });
  if (c.shifts_set_aside === 0) return base;
  return `${base} ${translate(locale, "{count} shift(s) were set aside after an appeal and count neither way.", { count: c.shifts_set_aside })}`;
}
